import clsx from 'classnames';

import styles from './ProgressBar.module.scss';
import { ProgressBarProps } from './types';

export const ProgressBar = ({ className, color = '#00a000', testId, value }: ProgressBarProps) => {
	const classNames = clsx(styles.progressBar, className);

	return (
		<div className={classNames} data-testid={testId} style={{ backgroundColor: `${color}33` }}>
			<div
				className={styles['progressBar--progress']}
				style={{ backgroundColor: color, width: `${value}%` }}
			/>
		</div>
	);
};
